export default "__VITE_ASSET__DtKLiYuY__"